

class commonUtils {
    constructor() {
    }
    getUrlParam(variable){
        let str = window.location.search.substring(1)
        let paramList = str.split('&')
        for(let i = 0; i < paramList.length; i++){
            let paramArr = paramList[i].split("=");
            if(paramArr[0] === variable) return paramArr[1]
        }
        return false;
    }
}
let u = new commonUtils();

export default u;